import { Component, Input, OnInit } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-invoice-gas-cost-analysis-chart',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './invoice-gas-cost-analysis-chart.component.html',
  styleUrl: './invoice-gas-cost-analysis-chart.component.css'
})
export class InvoiceGasCostAnalysisChartComponent implements OnInit {
  data: any;
  options: any;

  @Input() chartSpreadIndex: number[] = [0.09, 0.06];

  labels: string[] = ['Spread', 'Index'];

  constructor(private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.updateChart();
    const monthKeys = [
      'invoice.spread',
      'invoice.index',
    ];

    combineLatest(monthKeys.map((key) => this.translocoService.selectTranslate(key))).subscribe((translations) => {
      this.labels = translations;
      this.updateChart();
    });
  }

  updateChart(): void {
    Chart.register(ChartDataLabels);

    this.data = {
      labels: this.labels,
      datasets: [
        {
          label: this.labels[0],
          data: [this.chartSpreadIndex[0], 0],
          backgroundColor: '#E6EDED',
          barThickness: 50,
          borderRadius: 20,
        },
        {
          label: this.labels[1],
          data: [0, this.chartSpreadIndex[1]],
          backgroundColor: '#99B9B7',
          barThickness: 50,
          borderRadius: 20,
        }
      ]
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle: true,
            color: '#6C7278'
          }
        },
        tooltip: {
          callbacks: {
            label: (context: any) => `${context.dataset.label}: ${context.parsed.y}€`
          }
        },
        datalabels: {
          anchor: 'end',
          align: 'bottom',
          formatter: (value: number) => {
            return value > 0 ? `${value}€` : '';
          },

          color: '#000000',
          font: {
            weight: 'normal',
            size: 12,
            family: 'Gilroy',
          }
        }
      },
      scales: {
        x: {
          display: false,
          ticks: {
            font: {
              size: 12,
            }
          },
        },
        y: {
          display: false,
          ticks: {
            callback: (value: any) => `${value}€`,
            beginAtZero: true,
            font: {
              size: 12,
            }
          },
        },
      },
    };
  }
}
